import { CollectionPageData, WithContext } from "../types/schema.types";
import type { CollectionPage } from "schema-dts";
import { generateCollectionPage } from "../utils/schema-generators";

/**
 * Builds Schema.org CollectionPage structured data
 * @param collectionPageData - Collection page information for schema generation
 * @returns Schema.org CollectionPage JSON-LD object
 */
export function buildCollectionPageSchema(
  collectionPageData: CollectionPageData
): WithContext<CollectionPage> {
  const collectionPageSchema: WithContext<CollectionPage> = {
    "@context": "https://schema.org",
    ...generateCollectionPage(
      collectionPageData.name,
      collectionPageData.description,
      collectionPageData.url,
      collectionPageData.inLanguage,
      collectionPageData.breadcrumbs
    ),
  };

  return collectionPageSchema;
}
